module.exports = __webpack_public_path__ + "media/images/top/place/place2-9f674fe636a2ea298059699a5416fbc3.png";